module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00029.fc7d5cd0.jpg",
  width: 4992,
  height: 3328,
  bytes: 583615,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00029.fc7d5cd0.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00029.jpg
// module id = 287
// module chunks = 0